import { SET_CAROUSEL, FETCH_MEDIA } from "./constants";
import * as d3 from "d3-dsv";
import axios from "axios";

export const setCarousel = routeName => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		dispatch({
			type: SET_CAROUSEL,
			routeName,
			building
		});
		resolve(routeName);
	});
export const getCarousel = ({ state }) => () =>
	new Promise(resolve => {
		resolve(state);
	});

export const fetchMedia = () => dispatch =>
	new Promise(resolve => {
		const media = {
			images: [],
			videos: [],
			urls: []
		};
		Promise.all(
			[
				"./data/media/images/list.csv",
				"./data/media/videos/list.csv",
				"./data/media/urls.csv"
			].map(url =>
				axios(url)
					.then(res => (res.ok ? res.text() : Promise.reject(res.status)))
					.then(text =>
						d3
							.csvParse(text)
							.filter(item => item && item.id && item.id.length > 0)
					)
					.catch(err => {
						console.log(err);
					})
			)
		).then(value => {
			if (value.length > 0) {
				value.forEach((typeData, typeIndex) => {
					if (typeData) {
						const typeName = Object.keys(media)[typeIndex];
						if (typeData.length > 0) {
							typeData.forEach(item => {
								if (typeName === "urls") {
									media[typeName].push(item.id);
								} else {
									media[typeName].push(`/data/media/${typeName}/${item.id}`);
								}
							});
						}
					}
				});
			}
			dispatch({
				type: FETCH_MEDIA,
				media
			});
			resolve(media);
		});
	});
